import { Dispatch, SetStateAction } from 'react'

import { MessageBarState } from '@/common/app/message'
import { filterArrayWithIndex } from '@/common/util/array'
import { scrollToId } from '@/common/util/scroll'

import MessageBarList from '@/components/view/layouts/bar/MessageBarList'
import MessageBar from '@/components/view/molecules/bar/MessageBar'

interface Props {
  messageStates: MessageBarState[]
  setMessageStates: Dispatch<SetStateAction<MessageBarState[]>>
}

const FormMessageList = ({ messageStates, setMessageStates }: Props) => {
  const onClickLink = (linkId: string) => {
    scrollToId(linkId)
  }

  return (
    <>
      {messageStates.length > 0 && (
        <MessageBarList>
          {messageStates.map((messageState, index) => (
            <MessageBar
              key={index}
              type={messageState.type}
              onClickClose={() => {
                setMessageStates(filterArrayWithIndex(messageStates, index))
              }}
              onClickLink={
                !!messageState.linkId
                  ? () => messageState.linkId && onClickLink(messageState.linkId)
                  : undefined
              }
              linkText={messageState.linkText}
              center
            >
              {messageState.message}
            </MessageBar>
          ))}
        </MessageBarList>
      )}
    </>
  )
}

export default FormMessageList
